import React, {useContext, useEffect} from "react";
import {useQueryUniqueUsers} from "../../queries/pharmacy/hooks/useQueryUniqueUsers";
import {UserContext} from "../../hooks/userContext";
import Box from "@mui/material/Box";
import {useQueryUniquePharmacy} from "../../queries/pharmacy/hooks/useQueryUniquePharmacy";
import Paper from "@mui/material/Paper";
import {useQueryPharmacyOptions} from "../../queries/pharmacy/hooks/useQueryPharmacyOptions";
import PharmacyDetails from "./PharmacyDetails";
import PhysicalAddress from "./PhysicalAddress";
import OtherDetails from "./OtherDetails";
import PharmacyFiles from "./PharmacyFiles";
import PharmacyBusinessInformation from "./PharmacyBusinessInformation";
import { useSearchParams } from "react-router-dom";
import BrandLoader from "../../components/shared/BrandLoader/BrandLoader";

const PharmacyProfile:React.FunctionComponent = () => {
  const { id }: any = useContext(UserContext);
  const [searchParams] = useSearchParams();

  const {data: pharmacyUsersData, loading: pharmacyUsersLoading } = useQueryUniqueUsers({
    variables: { where: { id:  +id } },
  });

  const {data: pharmacyOptionData, loading: pharmacyOptionsLoading} = useQueryPharmacyOptions({});
  const {data: pharmacyData, loading: pharmacyLoading } = useQueryUniquePharmacy({
    variables: { where: { id: pharmacyUsersData.findUniqueUser.PharmacyUsers[0].pharmacyId } },
    skip: !pharmacyUsersData
  });

  useEffect(() => {
    const section = searchParams.get('section');
    if (section !== 'business-information') {
      return;
    }

    // Wait for async section render then scroll into view.
    const timeoutId = setTimeout(() => {
      const el = document.getElementById('business-information-section');
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);

    return () => clearTimeout(timeoutId);
  }, [searchParams, pharmacyUsersData, pharmacyData]);

  if (pharmacyUsersLoading || pharmacyLoading || pharmacyOptionsLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 12 }}>
        <BrandLoader size={48} />
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          gap: 2,
          mb: 2,
          alignItems: { xs: 'stretch', lg: 'stretch' },
        }}
      >
        <Paper sx={{ p: 2, flex: { xs: '1 1 auto', lg: '65 1 0' }, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          <PharmacyFiles
            pharmacy={pharmacyData.findUniquePharmacy}
            statuses={pharmacyOptionData.findManyStatus}
          />
        </Paper>
        <Paper
          sx={{
            p: 2,
            flex: { xs: '1 1 auto', lg: '35 1 0' },
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <PharmacyBusinessInformation
            data={pharmacyData.findUniquePharmacy}
          />
        </Paper>
      </Box>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <PharmacyDetails
          data={pharmacyData.findUniquePharmacy}
          states={pharmacyOptionData.findManyState}
          pharmacyId={pharmacyUsersData.findUniqueUser.PharmacyUsers[0].pharmacyId}
        />
      </Paper>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <PhysicalAddress
          data={pharmacyData.findUniquePharmacy.PharmacyAddress}
          states={pharmacyOptionData.findManyState}
          pharmacyId={pharmacyUsersData.findUniqueUser.PharmacyUsers[0].pharmacyId}
        />
      </Paper>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <OtherDetails
          data={pharmacyData.findUniquePharmacy.PharmacyDetail}
          pharmacyId={pharmacyUsersData.findUniqueUser.PharmacyUsers[0].pharmacyId}
          pharmacyTypes={pharmacyOptionData.findManyPharmacyType}
        />
      </Paper>
    </>
  );
}

export default PharmacyProfile;